import client from "../client/client";

class CompanyService {
	getAllUser({ companyId }, cancelToken) {
		return client.get(`/companies/${companyId}/users`, { config: { cancelToken } });
	}
}

export default new CompanyService();
